import React, { Component } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import moment from "moment";
import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  Grid,
  Typography,
  CircularProgress,
  Container,
  Tooltip,
  Switch,
  Checkbox,
} from "@mui/material";
import { QueuePlayNext, DeleteForever, Label, Help } from "@mui/icons-material";
import { withStyles } from "@mui/styles";
import { Styles } from "../../styles/material-styles";
import { Overlay } from "../../styles/global";
import Api from "../../services/api";
import CustomizedSnackbars from "../../components/material-snackbars";
import Dropzone from "react-dropzone";
import HeaderMenu from "../../components/header-menu";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import SimpleSelect from "../../components/select/simple";
import MyTransferList from "../../components/transfer-list/transferlist";
import MyCheckList from "../../components/checklist/checklist";
import SimpleAutoCompleteMultiple from "../../components/auto-complete/autocomplete-multiple-create";
import SimpleDatePicker from '../../components/date-pickers/inline-no-today';
import SimpleAutoComplete from "../../components/auto-complete/autocomplete";
import Footer from "../../components/footer";
import { browserHistory } from "../../helpers/history";
import { FormattedMessage, injectIntl } from "react-intl";
import Title from "../../components/title-name";
import SimpleCheckBox from "../../components/checkbox/check";
import Autocomplete from "@mui/material/Autocomplete";
import { getAllWithoutIncludes } from '../../services/unit.service'
import { getAll as getStates } from '../../services/states.service.'
import {  getAllContactPreference } from '../../services/user.service'
import {  getEnableTagsOnusers } from '../../services/configusers.service'
import { saveAs } from "file-saver";
import { Input } from "@mui/material";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/material.css'
import { getOrg } from "../../services/organization.service";
import * as Service from "../../services/user.service";
import { DataGrid, GridToolbarFilterButton } from '@mui/x-data-grid';
import ClearIcon from '@mui/icons-material/Clear'
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DialogConfirmation from '../../components/dialog-confirmation'
import NumberFormat from "react-number-format"
import SimpleHelp from "../../components/help"
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import { PapiroConsole } from "../../utils/papiroConsole";
import DialogAddMultiple from "../../components/dialog-add-multiple";
import { Box, Chip } from "@mui/material";
import { bindActionCreators } from 'redux';
import * as componentActions from '../../redux/actions/users';
import { AbilityContext } from '../../config/ability-context'
import { can } from '../../config/ability'






class UserCopyProfile extends Component {
    constructor(props) {
        super(props);

        this.typingTimeout = null;


        const { userSession } = this.props;
        const intl = this.props.intl;

        this.genderList = [
        { id: 1, name: intl.formatMessage({ id: "gender.male" }) },
        { id: 2, name: intl.formatMessage({ id: "gender.female" }) }
        ]

        this.stateList = [
        { id: 1, name: 'Acre' },
        { id: 2, name: 'Alagoas' },
        { id: 3, name: 'Amapá' },
        { id: 4, name: 'Amazonas' },
        { id: 5, name: 'Bahia' },
        { id: 6, name: 'Ceará' },
        { id: 7, name: 'Espírito Santo' },
        { id: 8, name: 'Goiás' },
        { id: 9, name: 'Maranhão' },
        { id: 10, name: 'Mato Grosso' },
        { id: 11, name: 'Mato Grosso do Sul' },
        { id: 12, name: 'Minas Gerais' },
        { id: 13, name: 'Pará' },
        { id: 14, name: 'Paraíba' },
        { id: 15, name: 'Paraná' },
        { id: 16, name: 'Pernambuco' },
        { id: 17, name: 'Piauí' },
        { id: 18, name: 'Rio de Janeiro' },
        { id: 19, name: 'Rio Grande do Norte' },
        { id: 20, name: 'Rio Grande do Sul' },
        { id: 21, name: 'Rondônia' },
        { id: 22, name: 'Roraima' },
        { id: 23, name: 'Santa Catarina' },
        { id: 24, name: 'Sao Paulo' },
        { id: 25, name: 'Sergipe' },
        { id: 26, name: 'Tocantins' },
        { id: 27, name: 'Distrito Federal' }
        ]


        this.initialState = {
            startPage: '',
            createdUser: userSession.user.id,
            createdAt: moment().format("YYYY/MM/DD HH:mm:ss"),
            Organizations: 0,
            Location: 0,
            Groups: 0,
            OrganizationText: "",
            GroupText: "",
            LocationText: "",
            name: "",
            email: "",
            document: "",
            gender: null,
            contactPreferenceId : null,
            state: 0,
            unitId: 0,
            active: false,
            canUserViewArchivedCalleds: false,
            canCreateCalledInMobile: false,
            canInteractWithCalledWhereAreNotRequesterOrAssigned: false,
            phone: "",
            employeehourvalue: 0,
            valueforcalled: 0,
            kmvaluerotated: 0,
            UserRoles: [],
            LocationId: [],
            WorkHourId: '',
            WorkHourText: "",
            OrganizationDepartamentId: 0,
            perhour: false,
            calledunit: false,
            isUnityObrigatory: userSession.user.isunityobrigatory,
            isCostControlObrigatory: userSession.user.iscostcontrolobrigatory,
            defaultorganization: "",
            DateOfBirth : null,
            copyProfile: false,
            allUsersArray: [],
            userReferenceId: 0,
            loading: false,
            copyOrgs: true,
            copyLocations: true,
            copyTeams: true,
            copyDepartaments: true,
            userReferenceIdDisabled: false,
     
        };

        this.state = {
            loading: false,
            openNotification: false,
            notificationVariant: "error",
            notificationMessage: "",
            resultList: [],
            file: null,
            arrayAgents: [],
            openDialogNewAgents: false,
            valueNewAgents: 0,
            newAgentsAccept: false,
            item: this.initialState,
            itemError: {},
            statesList: [],
            unitList: [],
            OrgListForSelect: [],
            LocationListForSelect: [],
            DepartamentList: [],
            LocationList: [],
            OrganizationList: [],
            WorkHoursList: [],
            RolesList: [],  
            contactPreferenceList: [],
            genderList: this.genderList,
            enableTagsOnUsers: [],
            dialogOpen: false,
            dialogTitle: "",
            dialogText: "",
            dialogType: "",
            dialogFunction: null,
            openLocationInsertModal: false,
            departamentName: "",
            locationReset: [],
            isAdmGlobal: false,
            AdmOrganization: false,
            userId: 0,
        };

        this.getAllUsers = this.getAllUsers.bind(this);
        this.changeValues = this.changeValues.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.emailExists = this.emailExists.bind(this);
        this.handleChangePhone = this.handleChangePhone.bind(this)
        this.closeNotification = this.closeNotification.bind(this);
        this.getUserIdFromAgentList = this.getUserIdFromAgentList.bind(this);

        var globalAdm = false;
        this.AdmOrganization = false;
        this.isAdmGlobal = false;
        this.userId = userSession.user.id;
        if (userSession && userSession.user) {
            userSession.user.userrole.map((item, key) => {
                if (item.role.roletype == 0) {
                    globalAdm = true;
                    this.isAdmGlobal = true;
                }
                if (item.role.roletype == 1 && globalAdm == false) {
                    this.AdmOrganization = true;
                }
            });
        }

    }

    closeLocationModal = () => this.setState({ openLocationInsertModal: false })

    componentWillReceiveProps(nextProps) {
        if (nextProps.location.state === "reload") {
            this.componentDidMount();
        }
    }
    componentDidMount() {
        this.getStates();
        this.getContactPreferenceList();
        this.getAllUsers();
        this.getUserIdFromAgentList();
    }

    async getStates() {
        let result = await getStates()
        if (result && result.success) {
        if (result.data && result.data.length > 0)
            this.setState({ statesList: result.data })
        } else {
        const intl = this.props.intl;
        this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: "error",
            notificationMessage:
            result.response && result.response.data && result.response.data.errors
                ? result.response.data.errors[0]
                : intl.formatMessage({ id: "process.error" }),
        });

        Api.kickoff(result);
        }
    }

    async changeValues(stateName, value, text = "") {
        this.setState({ loading: true });

        this.setState((prevState) => ({
            item: {
            ...prevState.item,
            [stateName]: value,
            },
        }));
        this.setState({ loading: false });
    }

    handleInputChange(e) {
        const name = e.target.name;
        const value = e.target.value;

        if (e.target.name === "phone") {
            this.setState((prevState) => ({
                item: {
                ...prevState.item,
                ["phone"]: this.mtel(value),
                },
            }));
        } else if (name === 'document') {

            var valor = 0;

            if (value.length <= 14) {
                valor = this.cpfMask(value)
            } else {
                valor = this.CNPJMask(value)
            }
            valor.length === 0 ? this.setState(prevState => ({ itemError: { ...prevState.itemError, document: '' } })) : ((value.replace(/[.\-/]/g, '').length !== 14 && value.replace(/[.\-/]/g, '').length !== 11) || !this.isCPFOrCNPJValid(value)) ? this.setState(prevState => ({ itemError: { ...prevState.itemError, document: 'CPF/CNPJ inválido' } })) : this.setState(prevState => ({ itemError: { ...prevState.itemError, document: '' } }))
                this.setState(prevState => ({
                    item: {
                    ...prevState.item,
                    [name]: valor
                    }
                }))
        } else if (name === 'email') {
            this.setState((prevState) => ({
                item: {
                ...prevState.item,
                [name]: value.toLowerCase(),
                },
            }));
        
        } else {
            this.setState((prevState) => ({
                item: {
                ...prevState.item,
                [name]: value,
                },
            }));
        }            
    }

    handleChangePhone(e) {
        this.setState(prevState => ({
        item: {
            ...prevState.item,
            ['phone']: e
        }
        }));
    }

    handleCheckboxChange = (e) => {
        const { name, checked } = e.target;

        this.setState((prevState) => ({
            item: {
            ...prevState.item,
            [name]: checked
            }
        }));
    };

    emailExists = e => {
    const intl = this.props.intl;
    this.setState({ loading: true });
    const name = e.target.name;
    const value = e.target.value;

    if (name === "email") {
        if (value.length > 0) {
        let data = new FormData();
        data.append("email", value)

        Api.post("/users/emailexists", data)

            .then((result) => {
            if (result.data.success) {
                this.setState({ loading: false });
                if (result.data.data && result.data.data.id && result.data.data.id > 0) {
                let errorMessage = intl.formatMessage({ id: "email.already.registered" })

                if (result.data.data.userroles && result.data.data.userroles.length > 0) {
                    if (result.data.data.userroles.length > 1) {
                    errorMessage += intl.formatMessage({ id: "profile.text.header" })
                    result.data.data.userroles.map((item, idx) => {
                        if (idx == 0)
                        errorMessage += item.role.displayname
                        else
                        errorMessage += ` ,${item.role.displayname}`
                    })
                    } else {
                    errorMessage += intl.formatMessage({ id: "profile.text" }) + ` ${result.data.data.userroles[0].role.displayname}`
                    }
                }

                this.setState({
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage: errorMessage
                });
                }
            } else {
                this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage:
                    result.data && result.data.errors
                    ? result.data.errors[0]
                    : intl.formatMessage({ id: "process.error" }),
                });
                Api.kickoff(result);
            }
            })
            .catch((err) => {
            if (err && err.response && err.response.data && err.response.data.errors && err.response.data.errors[0]) {
                if (!isNaN(err.response.data.errors[0])) {
                this.setState({
                    loading: false,
                    openDialogNewAgents: true,
                    valueNewAgents: err.response.data.errors[0],
                });
                } else {
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                    err.response && err.response.data && err.response.data.errors
                        ? err.response.data.errors[0]
                        : intl.formatMessage({ id: "process.error" }),
                });
                }
            } else if (err.response && err.response.data && err.response.data.errors) {
                this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage:
                    err.response && err.response.data && err.response.data.errors
                    ? err.response.data.errors[0]
                    : intl.formatMessage({ id: "process.error" }),
                });
            } else {
                this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage:
                    err.response && err.response.data.errors
                    ? err.response.data.errors[0]
                    : intl.formatMessage({ id: "process.error" }) + err.response,
                });
            }
            });
        } else {
        this.setState({ loading: false });
        }
    }
    }

    async getAllUsers() {
        
        this.setState({ loading: true });  
        try {
          const result = await Api.get('/users/list/agents');
          if (result.data.success) {
            const allAgents = result.data.data;
            const arrayAgents = allAgents.map(agent => ({id: agent.id, name: agent.name}));
            this.setState({
              arrayAgents: arrayAgents,
              loading: false
            });
          }
        } catch (err) {
          console.error("Erro ao buscar usuários:", err);
          this.setState({ loading: false });
        }
    }

    async getContactPreferenceList() {
        let result = await getAllContactPreference()
        if (result && result.success) {
        if (result.data && result.data.length > 0)
            this.setState({ contactPreferenceList: result.data })
        } else {
        const intl = this.props.intl;
        this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: "error",
            notificationMessage:
            result.response && result.response.data && result.response.data.errors
                ? result.response.data.errors[0]
                : intl.formatMessage({ id: "process.error" }),
        });

        Api.kickoff(result);
        }
    }
    
    cpfMask = value => {
        return value
        .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
        .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1') // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
    }

    CNPJMask = (valor) => {
    const cleaned = valor.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    return cleaned
        .replace(/^(.{2})(.)/,        '$1.$2')
        .replace(/^(.{6})(.)/,        '$1.$2')
        .replace(/^(.{10})(.)/,       '$1/$2')
        .replace(/^(.{15})(.{1,2})$/, '$1-$2')
        .substring(0, 18);
};

    isCPFOrCNPJValid(value) {
        // Remove caracteres não numéricos
        const numericValue = value.replace(/\D/g, '');

        if (numericValue.length === 11) {
        // Validação CPF
        let sum = 0;
        let remainder;

        for (let i = 1; i <= 9; i++) {
            sum += parseInt(numericValue.substring(i - 1, i)) * (11 - i);
        }

        remainder = (sum * 10) % 11;

        if (remainder === 10 || remainder === 11) {
            remainder = 0;
        }

        if (remainder !== parseInt(numericValue.substring(9, 10))) {
            return false;
        }

        sum = 0;
        for (let i = 1; i <= 10; i++) {
            sum += parseInt(numericValue.substring(i - 1, i)) * (12 - i);
        }

        remainder = (sum * 10) % 11;

        if (remainder === 10 || remainder === 11) {
            remainder = 0;
        }

        return remainder === parseInt(numericValue.substring(10, 11));
        } else if (value.replace(/[.\-/]/g, '').length === 14) {
            const cleaned = value.replace(/[.\-/]/g, '').toUpperCase();
            const basePart = cleaned.substring(0, 12);
            const dvPart   = cleaned.substring(12);

            if (!/^\d{2}$/.test(dvPart)) return false;

            const charToValue = (c) => c.charCodeAt(0) - 48;
            const calcDV = (seq) => {
                let sum = 0, peso = 2;
                for (let i = seq.length - 1; i >= 0; i--) {
                    sum += charToValue(seq[i]) * peso;
                    peso = peso === 9 ? 2 : peso + 1;
                }
                const resto = sum % 11;
                return (resto === 0 || resto === 1) ? 0 : 11 - resto;
            };

            const dv1 = calcDV(basePart);
            if (dv1 !== parseInt(dvPart[0])) return false;
            const dv2 = calcDV(basePart + dv1.toString());
            return dv2 === parseInt(dvPart[1]);
        }
        return false;
    }

    validateCpf = value => {
        let sum, rest;

        sum = 0

        if (value == "00000000000" || value == "000.000.000-00") return false;

        value = value.replaceAll(".", "").replaceAll("-", "")

        for (let i = 1; i <= 9; i++) sum += parseInt(value.substring(i - 1, i)) * (11 - i)
        rest = (sum * 10) % 11

        if ((rest == 10) || (rest == 11)) rest = 0
        if (rest != parseInt(value.substring(9, 10))) return false

        sum = 0
        for (let i = 1; i <= 10; i++) sum += parseInt(value.substring(i - 1, i)) * (12 - i)
        rest = (sum * 10) % 11

        if ((rest == 10) || (rest == 11)) rest = 0
        if (rest != parseInt(value.substring(10, 11))) return false
        return true
    }

    verifyUserReferenceRoles(value){

    }

    closeNotification() {
        this.setState({ openNotification: false });
    }
    
    async getUserRoleIds(userReferenceId) {
        if (userReferenceId) {
            this.setState({ loading: true });

            let roles = await Service.getRolesByUser(userReferenceId);
            let roleIds = Array.isArray(roles) ? roles.map((role) => role.RoleId) : [];

            this.setState({ loading: false });

            return roleIds; 
        }
    }

    async validateOrganizationCopy(userReferenceId) {
        const intl = this.props.intl;
        
        if (userReferenceId) {
            try {
                let roles = await Service.getRolesByUser(userReferenceId);
                let roleIds = Array.isArray(roles) ? roles.map((role) => role.RoleId) : [];

                if (roleIds.includes(4) && !this.state.item.copyOrgs) {
                    return false;
                }
                
                return true;

            } catch (error) {
                console.error("Erro ao validar organização:", error);
                this.setState({ loading: false });
                return false;
            }
        }

        return true;
    }

    getUserIdFromAgentList = async () => {
        const { match } = this.props;
        const agentId = match.params.id;
        
        if (agentId) {
            try {
                const result = await Api.get(`/users/${agentId}`);
                if (result.data.success) {
                    const userData = result.data.data;
                    
                    this.setState(prevState => ({
                        item: {
                            ...prevState.item,
                            userReferenceIdDisabled: true,
                            userReferenceId: {
                                id: userData.id,
                                name: userData.name
                            }
                        }
                    }));
                }
            } catch (error) {
                console.error("Erro ao buscar usuário:", error);
                this.setState(prevState => ({
                    item: {
                        ...prevState.item,
                        userReferenceIdDisabled: true,
                        userReferenceId: { 
                            id: parseInt(agentId), 
                            name: `Usuário ${agentId}` 
                        }
                    }
                }));
            }
        }
    }

    openDialogNewAgents = () => {
        this.setState({
        openDialogNewAgents: !this.state.openDialogNewAgents
        })
    }

    handleSubmit = async (e) => {
        this.setState({ loading: true });
        const intl = this.props.intl;
        e.preventDefault();

        let data = new FormData();
        const { item } = this.state;
        const copyOrgs = this.state.item.copyOrgs;
        const copyDepartaments = this.state.item.copyDepartaments;
        const copyLocations = this.state.item.copyLocations;
        const copyTeams = this.state.item.copyTeams;

        if (!copyOrgs && !copyDepartaments && !copyLocations && !copyTeams) {
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: "Selecione ao menos uma opção para copiar"
            });
            return;
        }

        if (this.state.item.userReferenceId) {
            const isValid = await this.validateOrganizationCopy(this.state.item.userReferenceId.id);
            if (!isValid) {
                this.setState({
                    loading: false, 
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage: intl.formatMessage({ id: "copy.organizations.required" })
                });
                return;
            }
        }

        if (this.state.item.document && this.isCPFOrCNPJValid(this.state.item.document) == false) {
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: "O campo CPF/CNPJ não foi validado"
            });
            return;
        }

        if (this.state.newAgentsAccept) {
            data.append("acceptNewAgents", true);
            this.setState({ newAgentsAccept: false });
        }

        for (let key in this.state.item) {
            if(key == 'userReferenceId'){
                data.append(key, this.state.item[key]?.id);
            } else if(key == 'name'){
                data.append(key, this.state.item[key]);
            } else if(key == 'email'){
                data.append(key, this.state.item[key]);
            } else if(key == 'document'){
                data.append(key, typeof this.state.item[key] !== 'undefined' || this.state.user[key] !== null ? this.state.item[key] : "");
            } else if(key.toString().toLowerCase().indexOf("contactpreferenceid") > -1) {
                if(this.state.item[key] && this.state.item[key].id && this.state.item[key].id > 0) {
                    data.append(key, this.state.item[key].id);
                } else if (this.state.item[key] && this.state.item[key] > 0) {
                    data.append(key, this.state.item[key]);
                } else {
                    data.append(key, 0);
                }
            } else if (key.toString().toLowerCase().indexOf("dateofbirth") > -1) {
                if (this.state.item[key]){
                    const formattedDate = moment(this.state.item[key]).format('YYYY-MM-DD');
                    data.append(key, formattedDate);
                }
            }  else if(key == 'state'){
                data.append(key, this.state.item[key]);
            } else if(key == 'gender'){
                const genderValue = this.state.item[key] ? this.state.item[key] : 0;
                data.append(key, genderValue);
            } else if(key == 'phone'){
                data.append(key, this.state.item[key]);
            } else if(key == 'copyOrgs'){
                data.append(key, this.state.item[key]);
            } else if(key == 'copyDepartaments'){
                data.append(key, this.state.item[key]);
            } else if(key == 'copyLocations'){
                data.append(key, this.state.item[key]);
            } else if(key == 'copyTeams'){
                data.append(key, this.state.item[key]);
            }
        }

        let config = {
              headers: {
                "Content-Type": "multipart/form-data",
                dataType: "json",
              },
            };
        
            await Api.post("/users/CopyUserProfile", data, config)
        
              .then((result) => {
                if (result.data.success) {
                  this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "success",
                    notificationMessage: intl.formatMessage({ id: "add.success" }),
                    item: this.initialState,
                    openDialogNewAgents: false
                  });
        
                } else {
                  this.setState({
                    loading: false,
                    tags : [],
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                      result.data && result.data.errors
                        ? result.data.errors[0]
                        : intl.formatMessage({ id: "process.error" }),
                  });
                  Api.kickoff(result);
                }
              })
              .catch((err) => {
        
        
                if (err && err.response && err.response.data && err.response.data.errors && err.response.data.errors[0]) {
                  if (!isNaN(err.response.data.errors[0])) {
                    this.setState({
                      loading: false,
                      openDialogNewAgents: true,
                      valueNewAgents: err.response.data.errors[0],
                    });
        
                  } else {
                    this.setState({
                      loading: false,
                      openNotification: true,
                      notificationVariant: "error",
                      notificationMessage:
                        err.response && err.response.data && err.response.data.errors
                          ? err.response.data.errors[0]
                          : intl.formatMessage({ id: "process.error" }),
                    });
                  }
        
                } else if (err.response && err.response.data && err.response.data.errors) {
        
                  this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                      err.response && err.response.data && err.response.data.errors
                        ? err.response.data.errors[0]
                        : intl.formatMessage({ id: "process.error" }),
                  });
                } else {
        
                  this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                    err && err.response && err.response.data && err.response.data.errors
                        ? err.response.data.errors[0]
                        : intl.formatMessage({ id: "process.error" }) + err.response,
                  });
                }
              });

    }

    handleSubmitAccept = async (e) => {
        await this.setState({ newAgentsAccept: true });
        await this.handleSubmit(e);
    }

    render() {
        const { classes, headerMenu, actionsHeaderMenu } = this.props;
        const intl = this.props.intl;
        const { item, itemError } = this.state;

        if (Api == null) {
            var l = this.props.match.params.lang;
            document.location.href = `/${l}/unavailable`
        }

        return (
            <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
                <HeaderMenu />
                <main
                    className={clsx(classes.content, {
                        [classes.contentShift]: headerMenu.open,
                    }, classes.actionsContent, {
                        [classes.actionscontentShift]: actionsHeaderMenu.open,
                    })}
                >
                    <div className={classes.drawerHeader} />
                    <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', paddingLeft: 0, marginLeft: 0 }}>
                        <CssBaseline />

                        <Dialog
                            open={this.state.openDialogNewAgents}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            >
                            <DialogTitle id="alert-dialog-title">{intl.formatMessage({ id: "dialog.title.warning.max.users.reached" })}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                {intl.formatMessage({ id: "warning.max.users.reached.first.half" })} {intl.formatMessage({ id: "currency" })} {this.state.valueNewAgents} {intl.formatMessage({ id: "warning.max.users.reached.second.half" })}
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.openDialogNewAgents} variant="contained" color="secondary" autoFocus >
                                {intl.formatMessage({ id: "cancel" })}
                                </Button>
                                <Button variant="contained" onClick={this.handleSubmitAccept} color="primary" >
                                {intl.formatMessage({ id: "accept" })}
                                </Button>
                            </DialogActions>
                        </Dialog>
                        
                        <div className={classes.paper} style={{ marginTop: 0 }}>
                            <Grid container spacing={6}>
                                <Grid item xs={12} sm={4}>
                                    <Button
                                    variant="outlined"
                                    color="primary"
                                    onClick={browserHistory.goBack}
                                    >
                                    {<FormattedMessage id="back" />}
                                    </Button>
                            </Grid>
                            <Grid xs={12} sm={4}></Grid>
                            </Grid>

                            <Avatar className={classes.avatar}>
                                <QueuePlayNext />
                            </Avatar>
                            <Typography component="h1" variant="h5">
                                {<FormattedMessage id="add.item" />}
                            <Title />
                            </Typography>
                            
                            <form
                                name="myForm"
                                className={classes.form}
                                onSubmit={this.handleSubmit}
                                encType="multipart/form-data"
                            >
                                <Grid xs={12} sm={12} container spacing={3} rowGap={2} rowSpacing={1} justifyContent={"flex-start"} alignItems={"flex-start"} style={{ marginTop: 10, margin: 5, padding: 10 }} >
                                    <Grid item xs={12} sm={12}>
                                        <SimpleAutoComplete
                                            label={intl.formatMessage({ id: "reference.user" })}
                                            name="userReferenceId"
                                            options={this.state.arrayAgents}
                                            stateName="userReferenceId"
                                            changeSelect={this.changeValues}
                                            selected={this.state.item.userReferenceId}
                                            disabled={this.state.item.userReferenceIdDisabled}
                                            required
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <TextField
                                            fullWidth
                                            label={intl.formatMessage({ id: "name" })}
                                            inputProps={{ maxLength: 100 }}
                                            autoComplete="fname"
                                            variant="outlined"
                                            name="name"
                                            onChange={this.handleInputChange}
                                            value={item.name}
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <TextField
                                            fullWidth
                                            label={intl.formatMessage({ id: "email" })}
                                            inputProps={{ maxLength: 255 }}
                                            autoComplete="femail"
                                            type="email"
                                            variant="outlined"
                                            name="email"
                                            onChange={this.handleInputChange}
                                            onBlur={this.emailExists}
                                            value={item.email}
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <TextField
                                            fullWidth
                                            label={intl.formatMessage({ id: "document" })}
                                            inputProps={{ maxLength: 255 }}
                                            autoComplete="fname"
                                            type="document"
                                            variant="outlined"
                                            name="document"
                                            onChange={this.handleInputChange}
                                            value={item.document}
                                            InputLabelProps={{ shrink: true }}
                                            error={itemError.document?.length > 0}
                                            helperText={itemError.document}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <SimpleAutoComplete
                                            label={intl.formatMessage({ id: "contact.preference" })}
                                            name="contactPreference"
                                            options={this.state.contactPreferenceList}
                                            stateName="contactPreferenceId"
                                            changeSelect={this.changeValues}
                                            selected={item.contactPreferenceId}
                                        />
                                        </Grid>
                    
                                        <Grid item xs={12}>
                                        <SimpleDatePicker label={intl.formatMessage({ id: "date.of.birth" })} name='DateOfBirth' stateName='DateOfBirth' changeDate={this.changeValues} currentDate={this.state.item.DateOfBirth} />
                                        </Grid>
                                        <Grid item sm={12} md={12} lg={6} >
                                        <SimpleSelect
                                            label={intl.formatMessage({ id: "location.state" })}
                                            name="state"
                                            options={this.state.statesList}
                                            stateName="state"
                                            changeSelect={this.changeValues}
                                            selected={item.state} />
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                        <SimpleSelect
                                            label={intl.formatMessage({ id: "gender" })}
                                            name="gender"
                                            options={this.state.genderList}
                                            stateName="gender"
                                            changeSelect={this.changeValues}
                                            selected={item.gender}
                                        />
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                        <PhoneInput
                                            inputStyle={{
                                            padding: '23.5px 14px 23.5px 58px',
                                            width: '100%'
                                            }}
                                            style={{
                                            marginTop: 16,
                                            marginBottom: 8
                                            }}
                                            id="phone"
                                            name="phone"
                                            country={'br'}
                                            value={item.phone}
                                            onChange={this.handleChangePhone}
                                            InputLabel={intl.formatMessage({ id: "phone" })}
                                            specialLabel={intl.formatMessage({ id: "phone" })}
                                            inputProps={{
                                            name: intl.formatMessage({ id: "cellphone" })
                                        }} />
                                    </Grid>


                                    <Grid spacing={3} rowGap={2} rowSpacing={1} justifyContent={"flex-start"} alignItems={"flex-start"} style={{ marginTop: 10, margin: 5, padding: 10}}>
                                        <Grid item xs={12} sm={12}> 
                                            <Grid item xs={12} sm={12}>
                                                <Checkbox
                                                    value={this.state.item.copyOrgs}
                                                    checked={this.state.item.copyOrgs}
                                                    name="copyOrgs"
                                                    onChange={this.handleCheckboxChange}
                                                />
                                                <FormattedMessage id="copy.organizations" />
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} sm={12}> 
                                            <Grid item xs={12} sm={12}>
                                                <Checkbox
                                                    value={this.state.item.copyDepartaments}
                                                    checked={this.state.item.copyDepartaments}
                                                    name="copyDepartaments"
                                                    onChange={this.handleCheckboxChange}
                                                />
                                               <FormattedMessage id="copy.departments" />
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} sm={12}> 
                                            <Grid item xs={12} sm={12}>
                                                <Checkbox
                                                    value={this.state.item.copyLocations}
                                                    checked={this.state.item.copyLocations}
                                                    name="copyLocations"
                                                    onChange={this.handleCheckboxChange}
                                                />
                                                <FormattedMessage id="copy.locations" />
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} sm={12}> 
                                            <Grid item xs={12} sm={12}>
                                                <Checkbox
                                                    value={this.state.item.copyTeams}
                                                    checked={this.state.item.copyTeams}
                                                    name="copyTeams"
                                                    onChange={this.handleCheckboxChange}
                                                />
                                                <FormattedMessage id="copy.teams" />
                                            </Grid>
                                        </Grid> 
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} style={{ marginTop: 15, display: 'flex', justifyContent: 'flex-end', marginTop: 15 }}>
                                    <Grid container justify="flex-end" style={{ justifyContent: 'flex-end' }}>
                                        <Grid item xs={12} sm={4}    >
                                        <Button
                                            type='submit'
                                            fullWidth
                                            variant='contained'
                                            color='primary'
                                            className={classes.submit}
                                        >
                                            {<FormattedMessage id="save" />}
                                        </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>

                            </form>
                        </div>

                        {this.state.loading && (
                            <Overlay>
                                <CircularProgress color="secondary" />
                            </Overlay>
                        )}
            
                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />
                    </Container>
                </main>
                <Footer/>
            <div/>
            </div>
        );
    };
};

// export default UserCopyProfile;

UserCopyProfile.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    actionsHeaderMenu: state.actionsHeaderMenu,
    headerMenu: state.headerMenu,
    userSession: state.userSession,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(componentActions, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(UserCopyProfile)));

UserCopyProfile.contextType = AbilityContext;